import { render } from "./EmployeePayrolls.vue?vue&type=template&id=12198b98&scoped=true"
import script from "./EmployeePayrolls.vue?vue&type=script&lang=js"
export * from "./EmployeePayrolls.vue?vue&type=script&lang=js"

import "./EmployeePayrolls.vue?vue&type=style&index=0&id=12198b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12198b98"]])

export default __exports__